import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "select-none hover:bg-primary-100" }
const _hoisted_2 = ["href"]
const _hoisted_3 = { class: "flex shrink grow flex-col gap-1.5 truncate" }
const _hoisted_4 = { class: "flex items-center gap-2" }
const _hoisted_5 = { class: "w-full max-w-max shrink grow truncate text-t3 font-semibold" }
const _hoisted_6 = { class: "text-t4 font-medium text-grey-600" }

import { computed, PropType } from 'vue'
import { $date } from '@/plugins'
import { type TicketStateType, TicketStateEnum } from '@/types/sword-desk/tickets/ticket.types'
import { capitalize } from '@/utils/filters'


export default /*@__PURE__*/_defineComponent({
  __name: 'ExistingTicket',
  props: {
  title: {
    type: String,
    required: true,
  },
  updatedAt: {
    type: String,
    required: true,
  },
  state: {
    type: String as PropType<TicketStateType>,
    required: true,
  },
  link: {
    type: String,
    required: true,
  },
},
  setup(__props) {

const props = __props

const tagColor = computed(() => {
  switch (props.state) {
    case TicketStateEnum.PENDING:
      return 'yellow'
    case TicketStateEnum.CLOSED:
    case TicketStateEnum.SOLVED:
      return 'green'
    case TicketStateEnum['ON HOLD']:
    case TicketStateEnum.HIDDEN:
      return 'grey'
    case TicketStateEnum.NEW:
    case TicketStateEnum.OPEN:
    default:
      return 'blue'
  }
})


return (_ctx: any,_cache: any) => {
  const _component_sword_icon = _resolveComponent("sword-icon")!
  const _component_sword_tag = _resolveComponent("sword-tag")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock("li", _hoisted_1, [
    _createElementVNode("a", {
      class: "flex justify-between gap-2 py-4 !text-grey-900",
      target: "_blank",
      href: __props.link
    }, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createTextVNode(_toDisplayString(__props.title), 1)
          ])), [
            [_directive_tooltip, __props.title]
          ]),
          _createVNode(_component_sword_icon, {
            name: "external-link",
            class: "!size-4 !fill-grey-600 !align-text-top"
          })
        ]),
        _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.$tc('COMMON.UPDATED')) + ": " + _toDisplayString(_unref($date)().howLongAgo(__props.updatedAt)), 1)
      ]),
      _createVNode(_component_sword_tag, {
        color: tagColor.value,
        class: "!pointer-events-none",
        size: "sm"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(capitalize)(__props.state)), 1)
        ], undefined, true),
        _: 1
      }, 8, ["color"])
    ], 8, _hoisted_2)
  ]))
}
}

})